"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderFeedback = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable sonarjs/no-duplicate-string */
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const react_1 = require("react");
const services_1 = require("../../services");
const orderReview_1 = require("../../services/orderReview");
const useOrderFeedback = (orderId, customerId) => {
    const tagService = (0, react_1.useMemo)(() => new orderReview_1.OrderReviewTagService(services_1.GoogleAnalyticsService), []);
    const [selectedScore, setSelectedScore] = (0, react_1.useState)(null);
    const [loadingScore, setLoadingScore] = (0, react_1.useState)(false);
    const [loadingComment, setLoadingComment] = (0, react_1.useState)(false);
    const [showSavedScoreTag, setScoreTag] = (0, react_1.useState)(false);
    const [showReviewDisclaimer, setShowReviewDisclaimer] = (0, react_1.useState)(false);
    const updateOrderReviewScore = (0, services_1.makeUpdateOrderReviewScore)(orderId);
    const handleClickScore = (0, lodash_debounce_1.default)((item) => __awaiter(void 0, void 0, void 0, function* () {
        if (loadingComment)
            return;
        const score = (item === null || item === void 0 ? void 0 : item.score) || null;
        const isSameItem = selectedScore === score;
        const newSelectedScore = isSameItem ? null : score;
        setSelectedScore(newSelectedScore);
        try {
            setScoreTag(false);
            setLoadingScore(true);
            yield updateOrderReviewScore({ score: newSelectedScore, customerId });
            tagService.callbackOrderReviewRatingSuccess(newSelectedScore);
            setSelectedScore(newSelectedScore);
            setScoreTag(Boolean(newSelectedScore));
        }
        catch (error) {
            tagService.callbackOrderReviewRatingError();
            flora_react_1.Toaster.notify({
                kind: 'error',
                origin: 'center-top',
                description: 'Não foi possível selecionar avaliação, tente novamente.',
            });
            setSelectedScore(selectedScore);
        }
        finally {
            setLoadingScore(false);
        }
    }), 300);
    const handleSubmitReview = (onSubmitted, comment) => __awaiter(void 0, void 0, void 0, function* () {
        if (!comment) {
            setLoadingComment(true);
            onSubmitted();
            return;
        }
        try {
            setLoadingComment(true);
            yield updateOrderReviewScore({ comment, customerId });
            onSubmitted();
            tagService.callbackOrderReviewCommentSuccess();
        }
        catch (error) {
            tagService.callbackOrderReviewCommentError();
            flora_react_1.Toaster.notify({
                kind: 'error',
                origin: 'center-top',
                description: 'Não foi possível enviar avaliação, tente novamente.',
            });
        }
        finally {
            setLoadingComment(false);
        }
    });
    const handleSubmitSkipReason = (reason, onSubmitted) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoadingScore(true);
            yield Promise.all([
                updateOrderReviewScore({ score: null, customerId }),
                (0, services_1.updateOrderDeliveryStatus)({ orderId, deliveryStatus: reason, customerId }),
            ]);
            onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted();
            tagService.callbackSkipSubmitSuccess(reason);
            flora_react_1.Toaster.notify({
                description: 'Resposta enviada com sucesso',
                kind: 'success',
                origin: 'center-top',
                showIcon: true,
                Icon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.ThumbUpOutlineIcon, {}),
            });
        }
        catch (error) {
            tagService.callbackSkipSubmitError();
            flora_react_1.Toaster.notify({
                kind: 'error',
                origin: 'center-top',
                description: 'Não foi possível enviar resposta, tente novamente.',
            });
        }
        finally {
            setLoadingScore(false);
        }
    });
    (0, react_1.useEffect)(() => {
        setShowReviewDisclaimer(Boolean(!selectedScore));
    }, [selectedScore]);
    return {
        selectedScore,
        setSelectedScore,
        loadingScore,
        setLoadingScore,
        loadingComment,
        setLoadingComment,
        showSavedScoreTag,
        setScoreTag,
        handleClickScore,
        handleSubmitReview,
        handleSubmitSkipReason,
        showReviewDisclaimer,
    };
};
exports.useOrderFeedback = useOrderFeedback;
